import React from 'react';
import { ArrowDown, MessageCircle } from 'lucide-react';
import { WHATSAPP_LINK } from '../constants';
import { POSITIONING } from '../content/positioning';

const CONTACT_LINK = `${WHATSAPP_LINK}?text=${encodeURIComponent(
  'Hola, quiero saber si Áncora puede encargarse de una tarea concreta de mi negocio. Necesito ayuda con...',
)}`;

export const HeroSection: React.FC = () => {
  return (
    <section id="hero" className="marketing-hero marketing-hero--trust-first">
      <div className="marketing-grid marketing-hero__grid">
        <div className="marketing-hero__copy">
          <p className="marketing-eyebrow">{POSITIONING.category}</p>
          <h1>
            <span>{POSITIONING.promiseLead}</span>{' '}
            <strong>{POSITIONING.promiseAction}</strong>
          </h1>
          <p className="marketing-hero__lead">
            Consulta tu agenda o tu CRM, recoge datos, prepara las citas, hace seguimiento
            y pasa el caso a tu equipo cuando hace falta una decisión.
          </p>

          <div className="marketing-hero__actions">
            <a
              className="marketing-button marketing-button--primary"
              href={CONTACT_LINK}
              data-marketing-event="hero_process_cta"
              target="_blank"
              rel="noreferrer"
            >
              <MessageCircle aria-hidden="true" size={19} />
              Cuéntanos qué necesitas
            </a>
          </div>

          <a className="marketing-hero__proof-link" href="#casos">
            Ver casos reales <ArrowDown aria-hidden="true" size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};
